import { useQuery, useQueryClient } from '@tanstack/react-query'
import { lazySyncDescriptions } from '@/lib/api/descriptions'

/**
 * Diff-basierter Descriptions-Sync beim Öffnen. Nur bei Änderungen werden
 * neue Content-Block-Versionen erstellt; danach Caches invalidieren.
 * Gibt zurück, ob der Sync gerade läuft (für den Sync-Indikator im Hero).
 */
export function useDescriptionsSync(productId: string | undefined): boolean {
  const queryClient = useQueryClient()
  const query = useQuery({
    queryKey: ['descriptions-lazy-sync', productId],
    queryFn: async () => {
      const result = await lazySyncDescriptions(productId as string)
      if (result.synced) {
        queryClient.invalidateQueries({ queryKey: ['channel-descriptions', productId] })
        queryClient.invalidateQueries({ queryKey: ['content-blocks', productId] })
      }
      return result
    },
    enabled: !!productId,
    staleTime: 5 * 60_000,
  })
  return query.isFetching
}
